/* eslint-disable import/no-cycle */
import {
  GridToolbarColumnsButton,
  GridToolbarQuickFilter,
  GridToolbarContainer,
  GridToolbarProps,
  GridToolbarFilterButton
} from '@mui/x-data-grid'
import { GridApiCommunity } from '@mui/x-data-grid/internals'
import { Dispatch, MutableRefObject, SetStateAction } from 'react'
import { OptionType, selectValueType } from 'src/api/BaseAPI.model'
import { UseReactToPrintFn } from 'react-to-print'
import styles from './CustomGridToolbar.module.scss'
import IconButton from '../../../IconButton/IconButton'

export type TableRowFilterStaticDataType = {
  key: string
  label: string
  placeholder: string
  options: OptionType[]
  isMultiSelect?: boolean
}

export type TableRowFilterValuesType = {
  key: string
  value: selectValueType
  onChange: (value: selectValueType) => void
}

export interface CustomGridToolbarProps extends GridToolbarProps {
  autosizeOptions: { expand: boolean }
  apiRef: MutableRefObject<GridApiCommunity>
  restoreColumnSizes: boolean
  setRestoreColumnSizes: Dispatch<SetStateAction<boolean>>
  hideColumnFilter?: boolean
  hideRowFilter?: boolean
  handleOnAddItem: () => void
  handleOnDeleteItems: (ids: string[]) => void
  selectedRowIds: string[]
  handlePrint?: UseReactToPrintFn
  hideActionsButtons?: boolean
}

function CustomGridToolbar({
  autosizeOptions,
  apiRef,
  restoreColumnSizes,
  setRestoreColumnSizes,
  hideColumnFilter = false,
  hideRowFilter = false,
  handleOnAddItem,
  handleOnDeleteItems,
  selectedRowIds,
  handlePrint,
  hideActionsButtons = false,
  ...gridToolbarProps
}: CustomGridToolbarProps) {
  const handleRestoreColumnSizes = () => {
    apiRef.current?.autosizeColumns(autosizeOptions)
    setRestoreColumnSizes(false)
  }

  const handleAddClick = () => {
    handleOnAddItem()
  }

  return (
    <>
      <GridToolbarContainer {...gridToolbarProps}>
        <div className={styles.tableHeader}>
          <div className={styles.tableHeaderButtonContainer}>
            <GridToolbarQuickFilter sx={{ height: '1.75rem' }} />
            {!hideRowFilter && (
              <GridToolbarFilterButton
                slotProps={{
                  button: {
                    startIcon: <i className="las la-filter icon-big" />
                  }
                }}
              />
            )}
            {!hideColumnFilter && (
              <GridToolbarColumnsButton
                slotProps={{
                  button: {
                    startIcon: <i className="las la-th-list icon-big" />
                  },
                  tooltip: { PopperProps: { sx: { display: 'none' } } }
                }}
              />
            )}
          </div>
          <div className={styles.tableHeaderButtonContainer}>
            {handlePrint && (
              <IconButton
                icon="las la-print"
                color="primary"
                onClick={handlePrint}
                disabled={selectedRowIds.length === 0}
              />
            )}
            {!hideActionsButtons ? (
              <IconButton
                icon="las la-plus"
                color="primary"
                onClick={handleAddClick}
              />
            ) : null}
            <IconButton
              icon="las la-sync-alt"
              color="primary"
              onClick={handleRestoreColumnSizes}
              disabled={!restoreColumnSizes}
            />
            {!hideActionsButtons ? (
              <IconButton
                icon="las la-trash"
                color="primary"
                onClick={() => {
                  handleOnDeleteItems(selectedRowIds)
                }}
                disabled={selectedRowIds.length === 0}
              />
            ) : null}
          </div>
        </div>
      </GridToolbarContainer>
    </>
  )
}

export function createCustomToolbar(toolbarProps: CustomGridToolbarProps) {
  return function CustomGridToolbarWrapper(props: GridToolbarProps) {
    return <CustomGridToolbar {...toolbarProps} {...props} />
  }
}
